import { useEffect, Suspense, lazy } from "react";
import { AnimatePresence } from "framer-motion";
import { useDispatch } from "react-redux";
import { ROUTING_PATHS } from "../settings";
import { StaticAppLoader } from "../components/apploader";
// import store from "../redux/store";
// import {  apiErrorsHandler, getErrorMessages } from "../api/httpclient";
// import { setCurrentTheme, setUserTheme } from "../redux/slices/currentthemeslice";
// import { setAppearance } from "../redux/slices/appearanceslice";
// import { resetService, setGlobalCommands, stopService } from "../redux/slices/dictaphoneslice";
// import { addNotification } from "../redux/slices/notificationsslice";
import {
  Routes as BrowserRoutes,
  Navigate,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { ProtectedRoutes } from "../components/protectedroutes";
import { MainLayout } from "../components/mainlayout";
import { HomePage } from "../pages/homepage";
import { LoginPage } from "../pages/loginpage";
import { NotFoundPage } from "../pages/notfoundpage";
import { UnAuthorizedPage } from "../pages/unauthorizedpage";
import { GenericErrorPage } from "../pages/genericerrorpage";
import { ExpressionsPage } from "../pages/expressions/expressionspage";
import { DataSourcesPage } from "../pages/datasources/datasourcespage";
import { DataCorrectionPage } from "../pages/datacorrection/datacorrectionpage";
import { AlertsPage } from "../pages/alerts/alertspage";
import { NotificationsPage } from "../pages/notifications/notificationspage";
import { ReportingLocatorPage } from "../pages/reporting/locator/reportinglocatorpage";
import { ReportingDesignPage } from "../pages/reporting/design/reportingdesignpage";
import { ReportingViewPage } from "../pages/reporting/view/reportingviewpage";
import { UsersPage } from "../pages/users/userspage";
import { SecurityGroupsPage } from "../pages/securitygroups/securitygroupspage";
import { MigrationsPage } from "../pages/migrations/migrationspage";
import { ReportsMenuPage } from "../pages/reportsmenu/reportsmenupage";
import { DataConsumptionPage } from "../pages/dataconsumption/dataconsumptionpage";
import { ResetPasswordPage } from "../pages/resetpassword/resetpasswordpage";

//import { beepFile, notificationDurationMiddle } from "../lib/utils";
import {
  canAccessExpressions,
  canAccessDataSources,
  canAccessAlerts,
  canAccessReports,
  canCreateOrEditReports,
  canAccessUsers,
  isUser,
  isRootSubscriptionUser,
  canAccessMigrations,
  canAccessDataConsumption,
  canAccessDataSet,
  canCreateDataset,
  canImportDataset,
  canEditDataset,
  canAccessData,
  canViewData,
  canCreateData,
  canEditData,
  canDeleteData,
  canCreateSchedule,
  canImportSchedule,
  canCreateConnection,
  canAccessConnection,
  canEditConnection,
  canDeleteConnection,
  canViewAnyConnection
} from "./authorizationhandlers";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { DatasetsLocatorPage } from "../pages/datasets/locator/datasetslocatorpage";
import { CreateDatasetPage } from "../pages/datasets/createdataset/createdatasetpage";
import { ImportDatasetPage } from "../pages/datasets/importdataset/importdatasetpage";
import { DatasetViewPage } from "../pages/datasets/datasetview/datasetviewpage";
import { FeaturesPage } from "../pages/features";
import { TermsPage } from "../pages/terms";
import { AccountManagementPage } from "../pages/accountmanagement/accountmanagementpage";
import { SubscriptionPage } from "../pages/subscription";
import { PrivacyPage } from "../pages/privacy";
import { SupportPage } from "../pages/support";
import { OnBoardingPage } from "../pages/onboarding/onboardingpage";
import { ScheduleLocatorPage } from "../pages/schedule/locator/schedulelocatorpage";
import { ScheduleViewPage } from "../pages/schedule/scheduleview/scheduleviewpage";
import { CreateSchedulePage } from "../pages/schedule/createschedule/createschedulepage";
import { ImportSchedulePage } from "../pages/schedule/importschedule/importschedulepage";
import { ConnectionLocatorPage } from "../pages/connection/locator/connectionlocatorpage";
//import {themes} from "../sass/themes";

// const ExpressionsPage = lazy(() => import('../pages/expressions/expressionspagedefault.js'));
// const DataSourcesPage = lazy(() => import('../pages/datasources/datasourcespagedefault.js'));
// const AlertsPage = lazy(() => import('../pages/alerts/alertspagedefault.js'));
// const NotificationsPage = lazy(() => import('../pages/notifications/notificationspagedefault.js'));
// const ReportingLocatorPage = lazy(() => import('../pages/reporting/locator/reportinglocatorpagedefault.js'));
// const ReportingDesignPage = lazy(() => import('../pages/reporting/design/reportingdesignpagedefault.js'));
// const ReportingViewPage = lazy(() => import('../pages/reporting/view/reportingviewpagedefault.js'));
// const UsersPage = lazy(() => import('../pages/users/userspagedefault.js'));
// const SecurityGroupsPage = lazy(() => import('../pages/securitygroups/securitygroupspagedefault.js'));

const pageFadeAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 2 },
};

export const GuestRoute = ({
  isAuthorized,
  redirectTo = "/accountmanagement",
  children,
}) => {
  return isAuthorized === true ? (
    <Navigate to={redirectTo} replace />
  ) : (
    children
  );
};

export const Routes = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { switcher } = useThemeSwitcher();

  const openPage = (path) => {
    navigate("/" + path);
    //beepFile("/sounds/open.mp3");
  };

  const keys = [65, 67, 68, 69, 71, 78, 82, 85, 86, 80, 83];

  const globalKeyDownHandler = (e) => {
    e = e || window.event;
    let key = e.which || e.keyCode;

    //pause debugger when F12 is pressed
    //console.log("KEY", key=123)
    if (key == 123) {
      debugger;
      return;
    }

    var alt = e.altKey ? e.altKey : key === 18 ? true : false;

    if (alt && keys.find((e) => e == key)) {
      if (key == 65)
        //a
        openPage("alerts");
      else if (key == 82 || key == 80)
        //r
        openPage("reports");
      else if (key == 67)
        //c
        window.location.href = "/reportingdesign/new";
      else if (key == 69)
        //e
        openPage("expressions");
      else if (key == 78)
        //i
        openPage("notifications");
      else if (key == 68)
        //d
        openPage("datasources");
      else if (key == 85)
        //u
        openPage("users");
      else if (key == 71)
        //g
        openPage("securitygroups");
      else if (key == 83)
        //s
        openPage("dataset");

      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };

  //global commands
  // useEffect(() => {
  //     const globalCommands = [
  //         {
  //             command: ['table * and', 'table * end'],// ([a-zA-Z0-9])* over ([a-zA-Z0-9])* and'],
  //             callback: (dataSource) => {
  //             }
  //         },
  //         {
  //             command: ['open *'],
  //             callback: (command) => {
  //               openPage("expressions");
  //             },
  //             // isFuzzyMatch: true,
  //             // fuzzyMatchingThreshold: 0.2,
  //             //bestMatchOnly: false
  //         },
  //         { command: ['open data sources'], callback: (command) => openPage("datasources") },
  //         { command: ['open alerts'], callback: (command) => openPage("alerts") },
  //         { command: ['open notifications'], callback: (command) => openPage("notifications")} ,
  //         { command: ['open reports'], callback: (command) => openPage("reports") },
  //         { command: ['open users'], callback: (command) => openPage("users") },
  //         { command: ['open home', 'go home'], callback: (command) => openPage("") },
  //         { command: ['new report', 'create report'], callback: (command) => openPage("reportingdesign/new") },

  //         { command: ['reset', 'restart'], callback: (command) => {
  //             beepFile("/sounds/start.mp3");
  //             dispatch(resetService());
  //         } },

  //         { command: ['go back', 'back'], callback: (command) =>
  //             {
  //                 beepFile("/sounds/open.mp3");
  //                 navigate(-1);
  //             }
  //         },
  //         { command: ['go next', 'next'], callback: (command) =>
  //             {
  //                 beepFile("/sounds/open.mp3");
  //                 navigate(1);
  //             }
  //         },

  //         { command: ['dark mode', 'seem dark'], callback: (command) =>
  //             {
  //                 const appearance = store.getState().appearance;

  //                 beepFile("/sounds/any.mp3");

  //                 dispatch(setUserTheme(22, appearance.isRightToLeft))
  //                 .then(
  //                     response =>{
  //                         dispatch(setCurrentTheme(themes["22"]));
  //                         switcher({theme: themes["22"]});
  //                     },
  //                     err =>
  //                     {
  //                         //hide loader
  //                         const handleResponseReceived = (state, dispatch, navigate, payload) => {
  //                             let errorMessages = payload?.data?.ErrorMessages;

  //                             if (!errorMessages || errorMessages.length == 0)
  //                                 errorMessages = ["An unknown error occured!"];
  //                             else
  //                                 errorMessages = getErrorMessages(errorMessages, 1);

  //                             dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
  //                         };

  //                         const handleUnhandled = (state, dispatch, navigate, payload) =>{
  //                             let errorMessage = "An unknown error occured!";
  //                             dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
  //                         };

  //                         apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
  //                     }
  //                 );
  //             }
  //         },

  //         { command: ['light mode', 'seem light'], callback: (command) =>
  //             {
  //                 const appearance = store.getState().appearance;

  //                 beepFile("/sounds/any.mp3");

  //                 dispatch(setUserTheme(1, appearance.isRightToLeft))
  //                 .then(
  //                     response =>{
  //                         dispatch(setCurrentTheme(themes["1"]));
  //                         switcher({theme: themes["1"]});
  //                     },
  //                     err =>
  //                     {
  //                         //hide loader
  //                         const handleResponseReceived = (state, dispatch, navigate, payload) => {
  //                             let errorMessages = payload?.data?.ErrorMessages;

  //                             if (!errorMessages || errorMessages.length == 0)
  //                                 errorMessages = ["An unknown error occured!"];
  //                             else
  //                                 errorMessages = getErrorMessages(errorMessages, 1);

  //                             dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
  //                         };

  //                         const handleUnhandled = (state, dispatch, navigate, payload) =>{
  //                             let errorMessage = "An unknown error occured!";
  //                             dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
  //                         };

  //                         apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
  //                     }
  //                 );
  //             }
  //         },

  //         { command: ['right to left'], callback: (command) =>
  //             {
  //                 const currentTheme = store.getState().currentTheme;

  //                 beepFile("/sounds/any.mp3");

  //                 dispatch(setUserTheme(currentTheme.id, true))
  //                 .then(
  //                     response =>{
  //                         dispatch(setAppearance({isRightToLeft: true}));
  //                     },
  //                     err =>
  //                     {
  //                         //hide loader
  //                         const handleResponseReceived = (state, dispatch, navigate, payload) => {
  //                             let errorMessages = payload?.data?.ErrorMessages;

  //                             if (!errorMessages || errorMessages.length == 0)
  //                                 errorMessages = ["An unknown error occured!"];
  //                             else
  //                                 errorMessages = getErrorMessages(errorMessages, 1);

  //                             dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
  //                         };

  //                         const handleUnhandled = (state, dispatch, navigate, payload) =>{
  //                             let errorMessage = "An unknown error occured!";
  //                             dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
  //                         };

  //                         apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
  //                     }
  //                 );
  //             }
  //         },

  //         { command: ['left to right'], callback: (command) =>
  //             {
  //                 const currentTheme = store.getState().currentTheme;

  //                 beepFile("/sounds/any.mp3");

  //                 dispatch(setUserTheme(currentTheme.id, false))
  //                 .then(
  //                     response =>{
  //                         dispatch(setAppearance({isRightToLeft: false}));
  //                     },
  //                     err =>
  //                     {
  //                         //hide loader
  //                         const handleResponseReceived = (state, dispatch, navigate, payload) => {
  //                             let errorMessages = payload?.data?.ErrorMessages;

  //                             if (!errorMessages || errorMessages.length == 0)
  //                                 errorMessages = ["An unknown error occured!"];
  //                             else
  //                                 errorMessages = getErrorMessages(errorMessages, 1);

  //                             dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
  //                         };

  //                         const handleUnhandled = (state, dispatch, navigate, payload) =>{
  //                             let errorMessage = "An unknown error occured!";
  //                             dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
  //                         };

  //                         apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
  //                     }
  //                 );
  //             }
  //         },

  //         { command: ["goodbye", "sleep", "shut down"], callback: (command) => {
  //             beepFile("/sounds/bye.mp3");
  //             dispatch(stopService());
  //         }},
  //     ];

  //     dispatch(setGlobalCommands(globalCommands));
  // }, []);

  useEffect(() => {
    window.addEventListener("keydown", globalKeyDownHandler);

    return () => {
      window.removeEventListener("keydown", globalKeyDownHandler);
    };
  }, []);

  return (
    // <AnimatePresence>
    <Suspense fallback={<StaticAppLoader />}>
      <BrowserRoutes>
        <Route path={ROUTING_PATHS.home} element={<MainLayout />}>
          <Route
            path={ROUTING_PATHS.home}
            key={Date.now()}
            element={<HomePage animation={{ ...pageFadeAnimation }} />}
          />
          <Route
            path={ROUTING_PATHS.features}
            key={Date.now()}
            element={<FeaturesPage animation={{ ...pageFadeAnimation }} />}
          />
          {/* <Route
            path={ROUTING_PATHS.subscription}
            key={Date.now()}
            element={<SubscriptionPage animation={{ ...pageFadeAnimation }} />}
          /> */}
          <Route
            path={ROUTING_PATHS.subscription}
            element={
              <GuestRoute isAuthorized={isUser} redirectTo="/accountmanagement">
                <SubscriptionPage animation={{ ...pageFadeAnimation }} />
              </GuestRoute>
            }
          />
          <Route
            path={ROUTING_PATHS.onboarding}
            key={Date.now()}
            element={<OnBoardingPage animation={{ ...pageFadeAnimation }} />}
          />
          <Route
            path={ROUTING_PATHS.terms}
            key={Date.now()}
            element={<TermsPage animation={{ ...pageFadeAnimation }} />}
          />
          <Route
            path={ROUTING_PATHS.privacy}
            key={Date.now()}
            element={<PrivacyPage animation={{ ...pageFadeAnimation }} />}
          />
          <Route
            path={ROUTING_PATHS.support}
            key={Date.now()}
            element={<SupportPage animation={{ ...pageFadeAnimation }} />}
          />
          <Route
            path={ROUTING_PATHS.login}
            key={Date.now()}
            element={<LoginPage />}
          />
          <Route
            path={ROUTING_PATHS.resetPassword}
            key={Date.now()}
            element={<ResetPasswordPage />}
          />
          <Route
            path={ROUTING_PATHS.unAuthorized}
            key={Date.now()}
            element={<UnAuthorizedPage animation={{ ...pageFadeAnimation }} />}
          />
          <Route
            path={ROUTING_PATHS.error}
            key={Date.now()}
            element={<GenericErrorPage animation={{ ...pageFadeAnimation }} />}
          />

          <Route
            element={<ProtectedRoutes isAuthorized={canAccessExpressions} />}
          >
            <Route
              path={ROUTING_PATHS.expressions}
              key={Date.now()}
              element={<ExpressionsPage animation={{ ...pageFadeAnimation }} />}
            />
          </Route>
          <Route
            element={<ProtectedRoutes isAuthorized={canAccessDataSources} />}
          >
            <Route
              path={ROUTING_PATHS.dataSources}
              key={Date.now()}
              element={<DataSourcesPage animation={{ ...pageFadeAnimation }} />}
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={canAccessAlerts} />}>
            <Route
              path={ROUTING_PATHS.alerts}
              key={Date.now()}
              element={<AlertsPage animation={{ ...pageFadeAnimation }} />}
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={isUser} />}>
            <Route
              path={ROUTING_PATHS.notifications}
              key={Date.now()}
              element={
                <NotificationsPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={isUser} />}>
            <Route
              path={ROUTING_PATHS.reports}
              key={Date.now()}
              element={
                <ReportingLocatorPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route
            element={<ProtectedRoutes isAuthorized={canCreateOrEditReports} />}
          >
            <Route
              path={ROUTING_PATHS.reportingDesign}
              key={Date.now().toString()}
              element={
                <ReportingDesignPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={isUser} />}>
            <Route
              path={ROUTING_PATHS.reportingView}
              key={Date.now().toString()}
              element={
                <ReportingViewPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={canAccessUsers} />}>
            <Route
              path={ROUTING_PATHS.users}
              key={Date.now()}
              element={<UsersPage animation={{ ...pageFadeAnimation }} />}
            />
          </Route>
          <Route
            element={<ProtectedRoutes isAuthorized={canAccessMigrations} />}
          >
            <Route
              path={ROUTING_PATHS.migrations}
              key={Date.now()}
              element={<MigrationsPage animation={{ ...pageFadeAnimation }} />}
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={canAccessUsers} />}>
            <Route
              path={ROUTING_PATHS.securityGroups}
              key={Date.now()}
              element={
                <SecurityGroupsPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route
            element={<ProtectedRoutes isAuthorized={isRootSubscriptionUser} />}
          >
            <Route
              path={ROUTING_PATHS.reportsMenu}
              key={Date.now()}
              element={<ReportsMenuPage animation={{ ...pageFadeAnimation }} />}
            />
          </Route>
          <Route
            element={
              <ProtectedRoutes isAuthorized={canAccessDataConsumption} />
            }
          >
            <Route
              path={ROUTING_PATHS.dataConsumption}
              key={Date.now()}
              element={
                <DataConsumptionPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={canAccessDataSet} />}>
            <Route
              path={ROUTING_PATHS.dataSets}
              key={Date.now()}
              element={
                <DatasetsLocatorPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>

          <Route element={<ProtectedRoutes isAuthorized={canAccessDataSet} />}>
            <Route
              path={ROUTING_PATHS.datasetView}
              key={Date.now().toString()}
              element={<DatasetViewPage animation={{ ...pageFadeAnimation }} />}
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={canCreateDataset} />}>
            <Route
              path={ROUTING_PATHS.createDataset}
              key={Date.now()}
              element={
                <CreateDatasetPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={canImportDataset} />}>
            <Route
              path={ROUTING_PATHS.importDataset}
              key={Date.now()}
              element={
                <ImportDatasetPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={canViewData} />}>
            <Route
              path={ROUTING_PATHS.dataCorrection}
              key={Date.now()}
              element={
                <DataCorrectionPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={isUser} />}>
            <Route
              path={ROUTING_PATHS.accountManagement}
              key={Date.now()}
              element={
                <AccountManagementPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>

          <Route element={<ProtectedRoutes isAuthorized={canAccessDataSet} />}>
            <Route
              path={ROUTING_PATHS.schedule}
              key={Date.now()}
              element={
                <ScheduleLocatorPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={canAccessConnection} />}>
            <Route
              path={ROUTING_PATHS.connection}
              key={Date.now()}
              element={
                <ConnectionLocatorPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={canAccessDataSet} />}>
            <Route
              path={ROUTING_PATHS.scheduleView}
              key={Date.now().toString()}
              element={
                <ScheduleViewPage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>

          <Route element={<ProtectedRoutes isAuthorized={canCreateSchedule} />}>
            <Route
              path={ROUTING_PATHS.createSchedule}
              key={Date.now()}
              element={
                <CreateSchedulePage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>
          <Route element={<ProtectedRoutes isAuthorized={canImportSchedule} />}>
            <Route
              path={ROUTING_PATHS.importSchedule}
              key={Date.now()}
              element={
                <ImportSchedulePage animation={{ ...pageFadeAnimation }} />
              }
            />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </BrowserRoutes>
    </Suspense>
    // </AnimatePresence>
  );
};
